import moment from "moment";
import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";

const Notification = () => {
  let location = useLocation();
  const navigate = useNavigate();
  //console.log(location);
  const [notification, setNotification] = useState([]);
  //console.log("object", notification);
  useEffect(() => {
    db.collection("notification")
      .get()
      .then((docs) => {
        let data = [];
        docs.forEach((i) => {
          data.push(i.data());
          //console.log(i.data());
        });
        setNotification([...data]);
      });
  }, []);
  return (
    <div class="container-fluid">
  <div class="container">
    <div class="row" style={{ paddingBottom: "40px", paddingTop: "40px" }}>
      <div class="col-md-10">
        <h1 style={{ textAlign: "center" }}>Notification</h1>
      </div>
      <div class="col-md-2" style={{ textAlign: "center" }}>
        <button onClick={() => { navigate("/dashboard/create"); }} class="btn btn-primary">Add New</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" style={{height: "400px", overflowY: 'scroll'}}>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Title</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {notification.sort((a,b)=>moment(b.date).valueOf() - moment(a.date).valueOf() ).map((i) => {
              return (
              <tr onClick={() => { navigate("notificationDetails", { state: { item: i } }); }}>
                <td>{i.title}</td>
                <td>{moment(i.date).format("D MMM, YYYY")}</td>
              </tr>
              );
            })}
            </tbody>
          </table>
      </div>
      <div class="col-md-6">
        <div style={{
            backgroundColor: "#dcdcdc40",
            borderRadius: 15,
            padding: '15px',
          }}>
          <Outlet />
        </div>
      </div>
    </div>

  </div>
</div>
  );
};

export default Notification;
